import {IntermediatePart} from "../../intermediatePart";

export default class ShowerGlass extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_glass';
    this.partName = 'Shower Glass';
    this.translateId = "visualizer.bathroom.shower.shower_glass";
    this.layerPriority = 12;
    this.canBeDisabled = true;
  }
}
